import Service from "../../Services";

const SupportContact = {
  namespaced : true,
  state : {
    form : {
      id : '',
      branch_id : '',
      reply_message : '',
      message : '',
      email : '',
      phone : '',
      is_reply : false,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
     state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        id : '',
        branch_id : '',
        reply_message : '',
        message : '',
        email : '',
        phone : '',
        is_reply : false,
      }
    }
  },
  actions : {
    getData({commit}, {page,sort,search}){
      return Service.CustomerSupportAPI.getContact(page,sort,search);
    },
    showData({commit},id){
      return Service.CustomerSupportAPI.showContact(id);
    },
    saveData({commit},{id,data}){
      if(id){
        return Service.CustomerSupportAPI.updateContact(id,data);
      }else{
        return Service.CustomerSupportAPI.createContact(data);
      }
    },
    deleteData({commit},id){
      return Service.CustomerSupportAPI.deleteContact(id);
    },
    setFormData({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    },
    //get Subscript
    getSubScribe({commit},{page,start_date,end_date,sort}) {
      return Service.CustomerSupportAPI.getSubScribe(
        page,
        start_date,
        end_date,
        sort
      );
    },
    getEnewsletterCategories () {
      return Service.CustomerSupportAPI.getEnewsletterCategories()
    },
    getEnewsletterCategoryById ({ commit }, id) {
      return Service.CustomerSupportAPI.getEnewsletterCategoryById(id)
    },
    deleteEnewsletterCategoryById ({ commit }, id) {
      return Service.CustomerSupportAPI.deleteEnewsletterCategoryById(id)
    },
    storeEnewsletterCategory ({ commit }, payload) {
      return Service.CustomerSupportAPI.storeEnewsletterCategory(payload)
    },
    editEnewsletterCategory ({ commit }, payload) {
      return Service.CustomerSupportAPI.editEnewsletterCategory(payload)
    },
    getEnewsletterSubscribe ({ commit }, payload) {
      return Service.CustomerSupportAPI.getEnewsletterSubscribe(payload)
    }
  },
}
export default SupportContact
